import type { SavedJourney } from '../types';

const STORAGE_KEY_PREFIX = 'routex_saved_journeys';

function storageKey(userId: string): string {
  return `${STORAGE_KEY_PREFIX}_${userId}`;
}

export function getSavedJourneys(userId: string): SavedJourney[] {
  try {
    const raw = localStorage.getItem(storageKey(userId));
    if (!raw) return [];
    const parsed = JSON.parse(raw) as SavedJourney[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveSavedJourney(userId: string, journey: Omit<SavedJourney, 'id' | 'savedAt' | 'name'>): SavedJourney {
  const list = getSavedJourneys(userId);
  const name =
    journey.startAddress && journey.endAddress
      ? `${journey.startAddress.slice(0, 25)}${journey.startAddress.length > 25 ? '…' : ''} → ${journey.endAddress.slice(0, 25)}${journey.endAddress.length > 25 ? '…' : ''}`
      : 'Saved journey';
  const saved: SavedJourney = {
    ...journey,
    id: `journey_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`,
    name,
    savedAt: Date.now(),
  };
  list.unshift(saved);
  localStorage.setItem(storageKey(userId), JSON.stringify(list));
  return saved;
}

export function removeSavedJourney(userId: string, journeyId: string): void {
  const list = getSavedJourneys(userId).filter((j) => j.id !== journeyId);
  localStorage.setItem(storageKey(userId), JSON.stringify(list));
}
